/* global Config */

// Vendor Libs
import React from 'react';
import {hot} from 'react-hot-loader/root';

// Styles
import './styles/styles.scss';
import {Provider} from 'react-redux';
import {SnackbarProvider} from 'notistack';
import {LocationProvider, Router} from '@reach/router';
import store, {history} from './redux/store';

import Main from './components/layout/main';
import MainPage from './components/main';

const basePath = Config.base.basePath || '/';

const App = () => (
  <Provider store={store}>
    <SnackbarProvider
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      maxSnack={5}
    >
      <LocationProvider history={history}>
        <Router>
          <Main path={basePath}>
            <MainPage path="/" />
            <MainPage path="/results" />
          </Main>
        </Router>
      </LocationProvider>
    </SnackbarProvider>
  </Provider>
);

export default Config.base.env === 'development' ? hot(App) : App;
